<template>
  <v-container fill-height fluid>
    <v-row align="center" justify="center" class="d-flex">
      <v-col style="background-color:rgba(255, 255, 255, 0.7);">
        К сожалению, ничего не удалось найти по вашему запросу.
        <br />
        <br />Возможно еще не все местоположения и таги внесены в базу.
        <br />
        <br />А если вы ищете по тексту или заголоввку статьи, то попробуйте
        искать без использования окончаний, потому что если вы ищите "деревня",
        а в тексте написано "в деревне", то мы пока не умеем такое искать.
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {}
</script>

<style></style>
